import React, { useState, useEffect } from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useParams } from 'react-router-dom';
import { getCustomerV2 } from 'utils/CustomersAPIUtils';
import Sidebar from 'components/modules/carrier/AdminSidebar';
import { onSaveCustomerDetails } from 'components/modules/user/customer-details';
import WebhooksList from 'components/modules/webhooks/List';
import PortProIntegration from 'components/modules/user/PortProIntegration';
import Spinner from 'components/ui/Spinner';
import { useTranslation } from 'react-i18next';
import CarrierEDISettings from './carrier-edi-settings';

const Loading = function () {
  return (
    <div className="justify-center lg:col-span-1" style={{ top: '50%' }}>
      <div className="align-middle">
        <span className="text-5xl text-green">
          <Spinner showMessage={false} />
        </span>
      </div>
    </div>
  );
};

const CarrierIntegrationSettings = () => {
  const { t } = useTranslation();
  const [carrier, setCarrier] = useState(null);
  const params = useParams();
  const carrierId = params.id;
  const renderSidebar = () => (
    <Sidebar userId={carrierId} activePage="integrations" />
  );

  const breadcrumbs = {
    pages: [
      {
        name: carrier?.name || t('CARRIER'),
        href: `/users/${carrierId}`,
        current: false,
      },
      {
        name: 'Integrations',
        href: `/users/${carrierId}/carrier-settings/integrations`,
        current: true,
      },
    ],
  };

  const fetchUser = async () => {
    const user = await getCustomerV2(carrierId);
    setCarrier(user);
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <LayoutWithSidebar
      sidebar={renderSidebar}
      breadcrumbs={breadcrumbs}
      className="py-4"
    >
      {carrier ? (
        <div className="lg:grid lg:grid-cols-2 lg:gap-4">
          <WebhooksList userId={carrier._id} accountType={carrier._type} />
          <PortProIntegration carrierId={carrier._id} />
          <CarrierEDISettings
            carrier={carrier}
            onCustomerPreferencesChange={onSaveCustomerDetails}
          />
        </div>
      ) : (
        <Loading />
      )}
    </LayoutWithSidebar>
  );
};

export default CarrierIntegrationSettings;
